module.exports = __webpack_public_path__ + "static/media/tpn-mission-statement.267cd9e4.jpg";